module.exports = __webpack_public_path__ + "img/rb3.b772b767.png";